export enum SourceType {
  Score = 'score',
  AudioImage = 'wave',
  Image3D = '3d',
  Grid = 'grid',
  Tab = 'tab',
  TabLinear = 'tab-linear',
  Lyrics = 'lyrics',
  TimeGrid = 'time-grid'
}
